import { BellOffIcon } from './BellOffIcon';

/**
 * author: Google
 * id 69686D8F-75FE-4091-9061-88DB64D95C01
 * name bell-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-off.svg
 * tags
 * - Notification 
 */
export const NotificationsOffIcon = BellOffIcon;
export default NotificationsOffIcon